/**
* VIP 兑换
*/
<template>
	<div style="margin-top: 60px;">

		<!-- 数据加载提示框 -->
		<van-overlay :show="isDataLoading" @click="show = false">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>

		<!-- 标题 -->
		<div class="center-container">
			<img style="width: 65px; height: 65px;" src="../../src/assets/main03_sys.jpg" />
			<p style="font-size: 24px;">{{ $t('language000071') }}</p>
		</div>

		<el-form ref="form" :model="form" label-width="80px">

			<el-form-item label="QIUI ID" style="margin-right: 40px;">
				<el-input v-model="form.userID" :placeholder="$t('language000072')"></el-input>
			</el-form-item>

			<el-form-item :label="$t('language000073')" style="margin-right: 40px;">
				<el-input v-model="form.code" :placeholder="$t('language000074')"></el-input>
			</el-form-item>

			<div style="display: flex;align-items: center;justify-content: center;">
				<el-button type="primary" @click="onSubmit">{{ $t('language000075') }}</el-button>
			</div>


		</el-form>

	</div>
</template>

<script>
	import axios from 'axios';

	export default {
		data() {
			return {
				isDataLoading: false, //加载数据提示框
				form: {
					userID: '',
					code: '',
				}
			}
		},
		mounted() {
			const userLanguage = navigator.language || navigator.userLanguage;
			const isLanguageSupported = this.$p_languages.includes(userLanguage);
			this.$i18n.locale = isLanguageSupported ? userLanguage : this.$p_defaultLanguage;
		},
		methods: {
			onSubmit() { //立即兑换
				if (this.form.userID.length <= 0) {
					this.openFail(this.$t('language000072') + "!");
					return;
				}
				if (this.form.code.length <= 0) {
					this.openFail(this.$t('language000074') + "!");
					return;
				}
				this.isDataLoading = true;
				axios.post(this.$p_url + '/feign/chargeMoney/convertCouponH5', {
						uid: this.form.userID,
						couponCode: this.form.code,
					}, {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
						},
					})
					.then(response => {
						this.isDataLoading = false;
						console.log("兑换的返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.openSuccess(this.$t('language000064') + "!");
							this.form.userID = "";
							this.form.code = "";
						} else {
							if (response.data.message === "vip_100024") {
								//兑换码失效
								this.openFail(this.$t('language000077') + "!");
							} else if (response.data.message === "vip_100025") {
								//兑换码不存在
								this.openFail(this.$t('language000078') + "!");
							} else
								this.openFail(this.$t('language000076') + "!");
						}

					})
					.catch(error => { // 请求失败时处理错误
						this.isDataLoading = false;
						this.openFail("请求失败:" + error);
						console.error('Error fetching data:', error);
					});
			},
			openSuccess(string) {
				this.$message({
					message: string,
					type: 'success'
				});
			},
			openFail(string) {
				this.$message.error(string);
			},
		}
	}
</script>

<style>
</style>